import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost } from "../utils/axios";

const GET_VOID_TRANSACTIONS_API =
  `${SERVER_URI}/manage-void-transaction/get-transactions`;

const VOID_TRANSACTION_API =
  `${SERVER_URI}/manage-void-transaction/void-transaction`;

export default {
  getVoidTransactions: async function (payload) {
    return apiPost(GET_VOID_TRANSACTIONS_API,payload);
  },

  voidTransaction: async function (payload) {
    return apiPost(VOID_TRANSACTION_API, payload);
  }
};
